import { CustomLayout, getChartsEditingSettings } from 'src/Libs/chart-kit'
import useChartLayout from 'src/Libs/chart-kit/shared/hooks/use-chart-layout'
import { useTypedSelector } from 'src/State/RootReducer'
import { DEFAULT_CHART_HEIGHT } from '../../shared'
import useAvailableLines from '../../shared/hooks/useAvailableLines'
import { getInitialPocPerformantChart } from '../utils/initial-chart-config'
import { useWallboxHardwareByStorage } from 'src/Libs/wallboxes/hooks'
import { UserSettings } from 'src/Libs/user/types'

interface ReturnType {
  chartLayout: CustomLayout
  initialChartLayout: CustomLayout
}

/**
 * This hook provides the layout for the proof of concept performant chart
 */
const usePocPerformantChartLayout = (userSettings: UserSettings): ReturnType => {
  const { data: wallboxes } = useWallboxHardwareByStorage()
  const powermeters = useTypedSelector(store => store.storage.powermeterHardware)

  const availableLines = useAvailableLines()
  const chartSettingsList = getChartsEditingSettings(userSettings)
  const initialChartLayout = getInitialPocPerformantChart(DEFAULT_CHART_HEIGHT, availableLines, wallboxes, powermeters)
  const { chartLayout } = useChartLayout(chartSettingsList, initialChartLayout)

  return { chartLayout, initialChartLayout }
}

export default usePocPerformantChartLayout
